import React, { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";


const OtpInput = ({ disabled, onSubmit, value, length = 4 }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [state, setState] = useState({
		token: new Array(length).fill(value||''),
	});

	const handleInput = ({ code, key, target }, i) => {
		if (key.length ===1) {
				if (!state.ready) {
					setState({
						...state,
						token: [...state.token.map((val, idx) => (idx === i ? key : val))],
					});
					target?.nextElementSibling?.focus();
					target.classList.remove("border-danger");
				}
		} else if(code === "Backspace") {
			setState({
				ready: false,
				token: [...state.token.map((val, idx) => (idx === i ? "" : val))],
			});
			target?.previousElementSibling?.focus();
		}
	};

	useEffect(() => {
		if (state.token.filter(Boolean).length === length) {
			setIsLoading(true);
		}else if (isLoading) setIsLoading(false);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.token]);

 const handlePaste = ({target: {value}}) => {
		if(value && value.length === length) {
			setState({ token: value.split("") });
		}
	}

	return (
		<>
			<div className="w-full">
				<div className="w-full" style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', alignContent: 'space-around', flexDirection: 'column', width: '100%', marginRight: 'auto', marginLeft: 'auto', marginTop: '2em'}}>
				<div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
					{state.token.map((token, i) => {
						return (
							<input
								className="xl:w-[50px] xl:h-[50px] w-[40px] h-[40px]"
								type="text"
								value={token}
								key={i}
								onChange={handlePaste}
        style={{border: '1px solid #111', borderRadius: '5px', textAlign: 'center', fontSize: '20px'}}
								placeholder="_"
								onFocus={(e) => e.target.select()}
								onKeyDown={(e) => handleInput(e, i)}
							/>
						);
					})}
				</div>
     <LoadingButton
          fullWidth
						sx={{".MuiLoadingButton-loadingIndicatorCenter": { color: '#fff'}
					, borderRadius: '10px', bgcolor: isLoading && 'var(--C_primary) !important', mt: '2em', '&:hover': {bgcolor: 'var(--C_primary) !important',}}}
          size="large"
          disabled={!isLoading}
          loading={disabled}
          variant="contained"
										onClick={_=> onSubmit(state.token.join(''))}
        >
          <span>Verify</span>
        </LoadingButton>
				</div>
			</div>
		</>
	);
};

export default OtpInput;